import HowItWorks from './HowItWorks.vue';

export { HowItWorks };
export default HowItWorks;
